









import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "CreatePostButtonView",
  components: { BaseButton, BaseIcon },
  props: {
    loading: { type: Boolean, required: true },
  },
  setup(_, { emit }) {
    const onClick = () => {
      emit("click");
    };

    return { onClick };
  },
});
